import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

import { CREAM, GREEN, INK } from "../components/tournament/PublicParts";
import { captainCheckin, captainCheckinView } from "../lib/tournamentApi";

/** Captain check-in via private token link — no account. */
export default function PublicCheckin() {
  const { slug, token } = useParams();
  const [view, setView] = useState(null);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    captainCheckinView(slug, token).then(setView).catch((e) => setError(e.message));
  }, [slug, token]);

  async function go() {
    setBusy(true);
    try { setView(await captainCheckin(slug, token)); }
    catch (e) { setError(e.message); }
    finally { setBusy(false); }
  }
  const done = view?.checkin_status === "checked_in";
  return (
    <div data-testid="captain-checkin" style={{ background: INK, color: CREAM, minHeight: "100vh", padding: "48px 22px",
                                               fontFamily: "system-ui, sans-serif" }}>
      <div style={{ maxWidth: 420, margin: "0 auto", textAlign: "center" }}>
        {error && <div data-testid="captain-checkin-error" style={{ fontSize: 16, lineHeight: 1.5 }}>{error}</div>}
        {view && (
          <>
            <div style={{ fontSize: 12, letterSpacing: "0.12em", textTransform: "uppercase", opacity: 0.7 }}>{view.tournament_name}</div>
            <h1 data-testid="captain-checkin-team" style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 48, margin: "8px 0 4px", lineHeight: 1 }}>
              {view.team_name}
            </h1>
            {view.location && <div style={{ opacity: 0.7, fontSize: 14 }}>{view.location}</div>}
            {done ? (
              <div data-testid="captain-checkin-done" style={{ marginTop: 40, animation: "pt-pop 300ms ease both" }}>
                <CheckCircle2 size={72} color="#4db87a" aria-hidden="true" />
                <div style={{ fontSize: 22, fontWeight: 800, marginTop: 10 }}>You're checked in.</div>
                <div style={{ opacity: 0.7, marginTop: 6, fontSize: 14 }}>The tournament desk can see you're here.</div>
                <a href={`/t/${slug}`} data-testid="captain-checkin-hub-link" style={{ display: "inline-block", marginTop: 24, color: CREAM }}>
                  See the bracket & schedule →
                </a>
              </div>
            ) : (
              <button data-testid="captain-checkin-button" onClick={go} disabled={busy}
                      style={{ marginTop: 48, width: "100%", minHeight: 120, borderRadius: 24, border: "none", cursor: "pointer",
                               background: GREEN, color: "#fff", fontSize: 30, fontWeight: 900, letterSpacing: "0.04em",
                               boxShadow: "0 12px 40px rgba(46,125,82,0.45)", transition: "transform 120ms ease" }}>
                {busy ? "Checking in…" : "We're here"}
              </button>
            )}
          </>
        )}
      </div>
      <style>{"@keyframes pt-pop { from { opacity: 0; transform: scale(0.9); } to { opacity: 1; transform: none; } }"}</style>
    </div>
  );
}
